import { createIcon } from '@integration-frontends/common/ui/icons/create-icon';
import React from 'react';
import './icon-success-checkmark.scss';

export const IconSuccessCheckmark = createIcon(<div className="icon-success-checkmark" />);
